import { withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "file-wapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "path1" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "path2" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "file-node__info" }
const _hoisted_6 = { class: "file-node__title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "file-node",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
    }, [
      (!_ctx.file.checkType)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "check-icon icomoon-checkbox",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)), ["stop"]))
          }))
        : (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: "check-icon icomoon-checkbox-checked",
            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)), ["stop"]))
          }, _hoisted_4)),
      _createElementVNode("span", {
        class: "file-node__icon",
        style: _normalizeStyle(`background-image: url(${_ctx.file.icon})`)
      }, null, 4),
      _createElementVNode("section", _hoisted_5, [
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.file.url), 1)
      ])
    ])
  ]))
}